(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["staff-app-k-one-cn"] = factory();
	else
		root["staff-app-k-one-cn"] = factory();
})(window, function() {
return 